export const DeviceCreateSceneTranslation = {
  fi: {
    DeviceCreateScene: {
      title: 'Lisää älylääkekaappi',
    },
  },
};
